import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { commentaryActs } from "@/mocks/film";

export default function CommentarySection() {
  const [activeId, setActiveId] = useState(commentaryActs[0].id);
  const active = commentaryActs.find((act) => act.id === activeId) ?? commentaryActs[0];

  return (
    <section id="commentary" className="scroll-mt-32 bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="05 / 分幕解说"
            title="逐幕解说：看点、伏笔与镜头语言"
            desc="这一部分不是复述剧情，而是按幕次拆解导演的处理方式，包括值得留意的细节、镜头调度与情绪节奏。切换幕次即可查看对应解说。"
          />
        </Reveal>

        <Reveal delay={60}>
          <div className="mt-8 md:mt-10 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-200">
            {commentaryActs.map((act) => (
              <button
                key={act.id}
                type="button"
                onClick={() => setActiveId(act.id)}
                className={`px-4 md:px-5 py-2 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                  activeId === act.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
                aria-pressed={activeId === act.id}
              >
                {act.label}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <Reveal className="lg:col-span-7" delay={40}>
            <div className="h-full rounded-lg bg-background-100 border border-background-200 p-5 md:p-7">
              <span className="font-label text-xs tracking-wider text-accent-600">
                {active.label} 解说
              </span>
              <h3 className="font-heading mt-2 text-xl md:text-2xl font-bold text-foreground-950">
                {active.title}
              </h3>
              <div className="mt-4 space-y-4 text-sm md:text-[15px] leading-relaxed text-foreground-700">
                {active.body.map((paragraph) => (
                  <p key={paragraph.slice(0, 16)}>{paragraph}</p>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={100}>
            <div className="h-full rounded-lg bg-primary-950 text-background-100 p-5 md:p-7">
              <h4 className="font-heading text-lg font-semibold text-background-50 flex items-center gap-2">
                <i className="ri-magic-line text-primary-300" aria-hidden="true" />
                值得留意的细节
              </h4>
              <ul className="mt-5 space-y-4">
                {active.highlights.map((point, index) => (
                  <li key={point} className="flex gap-3">
                    <span className="shrink-0 w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-label">
                      {index + 1}
                    </span>
                    <span className="text-sm leading-relaxed text-background-200/90">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}